import {
  actionCreator, API_URL,
  checkHttpStatus, create_post_data, createRequestActionTypes, createSearchUrl, jsonApiHeader,
  showErrorMessage, showSuccessMessage, showWarningMessage,
} from '../../../../../../../actions/utilAction';

export { jsonApiHeader, showWarningMessage, showErrorMessage, actionCreator, checkHttpStatus, create_post_data, createSearchUrl, showSuccessMessage };

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const POST_PATIENT_GENERAL_SETTINGS_API = `${API_URL}/api/PatientMasterGeneralSettings/SavePatientMasterGeneralSettings`;
export const GET_PATIENT_GENERAL_SETTINGS_API = `${API_URL}/api/PatientMasterGeneralSettings/GetPatientGeneralSettingsByPatientId`;

export const generalSettingsActionTypes = {
  get_masterData: createRequestActionTypes('GET_PATIENT_GENERAL_SETTINGS_MASTER_DATA'),
  save_patientGeneralSettings: createRequestActionTypes('SAVE_PATIENT_GENERAL_SETTINGS'),
  get_patientGeneralSettings: createRequestActionTypes('GET_PATIENT_GENERAL_SETTINGSDETAIL'),
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/generalSettings/constants/ApiConstants.js